/**
 * Detect whether an image_url value is an emoji character or a URL.
 * Returns true if the value is NOT a URL (i.e. it's an emoji or other text).
 */
export const isEmoji = (value) => {
    if (!value) return false;
    return !value.startsWith('http');
};

/**
 * Render an entity icon/image inline.
 * - If image_url starts with "http" → <img> tag
 * - If image_url is an emoji character → <span> with appropriate font-size
 * - If image_url is null/empty → returns null (caller should show fallback)
 */
export const renderEntityImage = (imageUrl, size = 36) => {
    if (!imageUrl) return null;

    if (imageUrl.startsWith('http')) {
        return (
            <img
                src={imageUrl}
                alt=""
                style={{
                    width: size,
                    height: size,
                    borderRadius: 8,
                    objectFit: 'cover',
                    flexShrink: 0,
                }}
                onError={(e) => { e.target.style.display = 'none'; }}
            />
        );
    }

    // Emoji character
    return (
        <span
            style={{
                fontSize: size * 0.65,
                lineHeight: `${size}px`,
                width: size,
                height: size,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
            }}
        >
            {imageUrl}
        </span>
    );
};
